import type { WorkOrderStatus } from "@myapp/contract";

export const isFollowUpRequired = (status: WorkOrderStatus): boolean =>
  status === "FOLLOW_UP_REQUIRED_1" || status === "FOLLOW_UP_REQUIRED_2";
